<template>
  <div class="consultInfo-card">
    <div class="left">
      <div class="img-box">
        <img :src="content.picture_url">
      </div>
      <div class="info-box">
        <p class="title">{{content.name}}</p>
        <p class="subtitle">{{content.description}}</p>
        <p class="category">{{content.category ? content.category.name : ""}}</p>
      </div>
      <!-- <div class="text-box">
        注意：此题库仅适用于  内蒙古大学 汉语文学专业
      </div> -->
    </div>
    <div class="right">
      <div class="button-wrap">
        <el-button class="button"
                   type="primary"
                   @click="handleConsultEdit">编辑基本信息</el-button>
      </div>
      <div class="text-wrap">
        <!-- <div class="exam-num">
          <p>{{content.exams ? content.exams.length : 0}}</p>
          <span>题库数量</span>
        </div> -->
      </div>
    </div>
    <ConsultEdit :visible="editDialog"
                 :content="content"
                 @close="editDialog = false"
                 @submit="handleSubmit"></ConsultEdit>
   
  </div>
</template>

<script>
import ConsultEdit from '@/components/dialog/consult/ConsultEdit'


export default {
  components: {
    ConsultEdit,
    
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      editDialog: false,
    }
  },
  methods: {
    // 题库编辑
    handleConsultEdit() {
      this.editDialog = true
    },
    handleSubmit() {
      this.$emit('submit')
    },
  },
}
</script>

<style lang="less" scoped>
.consultInfo-card {
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  border-radius: 4px;
  padding: 20px;
  overflow: hidden;

  display: flex;
  justify-content: space-between;

  .left {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    flex: 1;

    .img-box {
      margin-right: 15px;
    }
    img {
      width: 69px;
      height: 94px;
      object-fit: cover;
    }
    .info-box {
      display: flex;
      flex-direction: column;
    }
    .title {
      font-size: 18px;
      font-weight: bold;
    }
    .subtitle {
      flex: 1;
      margin-top: 10px;
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex: 1;

    .button-wrap {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }
    .text-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      & > div {
        text-align: center;
        padding: 0 30px;
      }
    }

    .member-num {
      border: 1px solid #ccc;
      border-width: 0 1px;
    }

    p {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
}
</style>
